import f from "./ghl-ui.es1539.js";
import c from "./ghl-ui.es1540.js";
import n from "./ghl-ui.es1536.js";
import m from "./ghl-ui.es1537.js";
import p from "./ghl-ui.es1538.js";
import s from "./ghl-ui.es1541.js";
import { Parser as Q } from "./ghl-ui.es1620.js";
import { parseNDigits as l } from "./ghl-ui.es1621.js";
var C = /* @__PURE__ */ function(u) {
  m(o, u);
  var i = p(o);
  function o() {
    var a;
    f(this, o);
    for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
      e[t] = arguments[t];
    return a = i.call.apply(i, [this].concat(e)), s(n(a), "priority", 120), s(n(a), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), a;
  }
  return c(o, [{
    key: "parse",
    value: function(r, e, t) {
      switch (e) {
        case "Q":
        case "QQ":
          return l(e.length, r);
        case "Qo":
          return t.ordinalNumber(r, {
            unit: "quarter"
          });
        case "QQQ":
          return t.quarter(r, {
            width: "abbreviated",
            context: "formatting"
          }) || t.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return t.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return t.quarter(r, {
            width: "wide",
            context: "formatting"
          }) || t.quarter(r, {
            width: "abbreviated",
            context: "formatting"
          }) || t.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, e) {
      return e >= 1 && e <= 4;
    }
  }, {
    key: "set",
    value: function(r, e, t) {
      return r.setUTCMonth((t - 1) * 3, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), o;
}(Q);
export {
  C as QuarterParser
};
